import { createWording } from "./create-wording";
import type { WordOptions } from "./create-wording";
import type { WordParams } from "./interpolate";
import { catalogue } from "./messages";

const defaultWording = createWording({ catalogue });

/** The console's words for a code. See `createWording` for the fallback rule. */
export function word(code: string, params?: WordParams, locale?: string, options?: WordOptions): string {
  return defaultWording.word(code, params, locale, options);
}

/** Whether the catalogue has words for a code in this locale (or a fallback of it). */
export function hasWord(code: string, locale?: string): boolean {
  return defaultWording.has(code, locale);
}
